<template>
  <div class="group-wrapper">
    <template v-if="tickets && tickets.length">
      <Ticket
        v-for="ticketInner in tickets"
        :key="ticketInner.id"
        :ticket="ticketInner"
        @ticketClick="onClick"
      />
    </template>
    <div class="message" v-else>
      {{ text | translate }}
    </div>
  </div>
</template>

<script>
  
import Ticket from './Ticket'
  
export default {
  props: ['tickets', 'text'],
  components: {
    Ticket
  },
  methods: {
    onClick(params) {
      this.$emit('ticketClick', params)
    }
  }
}
</script>

<style lang="scss" scoped>
  .group-wrapper {
    height: 100%;
  }
  .message {
    text-align: center;
    padding: 32px 16px;
    font-weight: 300;
    line-height: 150%;
    color: var(--label-secondary);
    font-feature-settings: 'ss02' on;
  }

  @media (max-width: 425px) {
    .message {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>
